import * as React from 'react'
import { SVGProps } from 'react'

const ALGOUSD = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.0005 31.9991C7.20078 31.9991 0.000976562 24.7995 0.000976562 15.9199C0.0809743 7.12031 7.20078 -0.0793359 16.0805 0.000660254C24.8803 0.0806564 32.0001 7.20031 32.0001 16.1599C31.9201 24.8795 24.8003 31.9991 16.0005 31.9991Z'
      fill='white'
    />
    <path
      d='M10.7663 23.9993L13.0802 19.9924L15.3941 15.9995L17.6938 11.9926L18.0748 11.3577L18.2441 11.9926L18.9495 14.631L18.1594 15.9995L15.8456 19.9924L13.5458 23.9993H16.3112L18.625 19.9924L19.8243 17.9184L20.3886 19.9924L21.4609 23.9993H23.9441L22.8718 19.9924L21.7995 15.9995L21.5174 14.9696L23.2386 11.9926H20.7273L20.6426 11.6963L19.7678 8.42302L19.655 7.99976H17.2423L17.1859 8.08441L14.9285 11.9926L12.6146 15.9995L10.3148 19.9924L8.00098 23.9993H10.7663Z'
      fill='black'
    />
  </svg>
)

export default ALGOUSD
